











































































import { CreateUserPostBodyI } from "@/models/admin/UserModel";
import { ACTION_CREATE_USER } from "@/store/actions-types";
import { Component, Prop, Vue } from "vue-property-decorator";
import PasswordFormGroup from "@/components/user-management/PasswordFormGroup.vue";
import { PasswordFormGroupModelI } from "@/models/admin/user-management/PasswordFormGroupModelI";
import { UserRoles } from "@/models/auth/AuthenticatedUser";
import { UserHelper } from "@/utils/UserHelper";
import { BValidationState } from "@/models/common/BValidationState";
import RoleBadge from "@/components/user-management/RoleBadge.vue";
import RoleSelector from "@/components/user-management/RoleSelector.vue";

@Component({
  components: {
    RoleSelector,
    RoleBadge,
    PasswordFormGroup,
  },
})
/**
 * Adds a button and modal with a form to create a new user
 */
export default class CreateUserBtnModal extends Vue {
  /**
   * The cpt data
   */
  @Prop({ required: false, default: [] }) currentUsers!: string[];

  /**
   * indicate if model is shown
   */
  public modalShow = false;

  /**
   * indicate if create user request pending
   */
  public isLoading = false;

  /**
   * indicate if password is hidden in form input
   */
  public hidePassword = true;

  /**
   * the username
   */
  public username = "";

  /**
   * the password and it's validation state
   */
  public passwordFormState: PasswordFormGroupModelI = {
    password: "",
    valid: null,
  };

  /**
   * the selected user role
   */
  public role = UserRoles.MOD;

  /**
   * check if username is valid
   */
  get usernameValid(): BValidationState {
    return UserHelper.isValidUsername(this.username, this.currentUsers);
  }

  /**
   * ensure form is fully valid
   */
  get formIsValid(): BValidationState {
    return this.passwordFormState.valid && this.usernameValid;
  }

  /**
   * toggle password visibility
   */
  toggleHidePassword(): void {
    this.hidePassword = !this.hidePassword;
  }

  /**
   * create a new user
   */
  async createUser(): Promise<void> {
    const user: CreateUserPostBodyI = {
      username: this.username,
      password: this.passwordFormState.password,
      role: this.role,
    };
    try {
      this.isLoading = true;
      await this.$store.dispatch(ACTION_CREATE_USER, user);
      this.modalShow = false;
      this.$emit("user-created");
      this.username = "";
      this.passwordFormState.password = "";
      this.passwordFormState.valid = null;
    } finally {
      this.isLoading = false;
    }
  }
}
